import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import type { QuoteStatusPayload } from './index';
import { toApiPayload } from './payload';

export interface QuoteStatusApiContract {
  update(payload: QuoteStatusPayload): Promise<void>;
  delete(): Promise<void>;
}

export class QuoteStatusApi extends ApiService implements QuoteStatusApiContract {
  constructor(
    api: ApiHandlerContract,
    private id: string,
  ) {
    super(api);
  }

  public update(payload: QuoteStatusPayload): Promise<void> {
    return this.api.proxy<void>({
      method: 'PATCH',
      path: '/v1/quote-statuses/{id}',
      params: { id: this.id },
      payload: toApiPayload(payload),
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy<void>({
      method: 'DELETE',
      path: '/v1/quote-statuses/{id}',
      params: { id: this.id },
    });
  }
}
